module.exports = __webpack_public_path__ + "static/media/pin.ae007b9c.svg";